import { httpGet, httpDel } from '@/tool/request/index';
//查询巡检记录（支持分页和过滤）
export async function iotDeviceReport(params) {
  return await httpGet<API.RootResponse>('/iot/device/report')({
    params,
  });
}

//删除巡检记录
export async function iotDeviceRecord(recordId) {
  return await httpDel<API.RootResponse>(`/iot/device/record/${recordId}`)();
}

//根据系统id查询设备上报关联日志
export async function iotDeviceReportLog(params) {
  return await httpGet<API.RootResponse>(`/iot/device/report/log/${params.systemId}`)({
    params
  });
}
